module.exports = __webpack_public_path__ + "d8f326f48515c3c38ead866b158eaa12.png";